//@ts-nocheck
import { faMinus, faPlus } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { motion } from "framer-motion";

export const AmountSelector = ({ changeAmount, quantity, size = "lg" }) => {
  return (
    <div className="gg-flex gg-items-center gg-gap-4 gg-px-3 gg-text-xs sm:gg-py-1.5">
      <motion.div
        whileHover={{ scale: 1.2 }}
        whileTap={{ scale: 0.9 }}
        transition={{ type: "spring", stiffness: 400, damping: 17 }}
        role="button"
        tabIndex={1}
        className="gg-cursor-pointer gg-border-none gg-text-center"
        aria-label="Decrease quantity"
        onClick={() => {
          if (quantity > 1) {
            changeAmount(-1);
          }
        }}
      >
        <FontAwesomeIcon
          icon={faMinus}
          size={size}
          className="gg-text-zinc-400 hover:gg-text-zinc-900"
        />
      </motion.div>
      <div className="gg-max-w-4 gg-w-0 gg-text-center gg-text-base gg-font-extrabold gg-text-zinc-900 sm:gg-text-lg">
        {quantity}
      </div>
      <motion.div
        whileHover={{ scale: 1.2 }}
        whileTap={{ scale: 0.9 }}
        transition={{ type: "spring", stiffness: 400, damping: 17 }}
        role="button"
        tabIndex={2}
        className="gg-cursor-pointer gg-border-none gg-pl-2 gg-text-center"
        aria-label="Increase quantity"
        onClick={() => changeAmount(1)}
      >
        <FontAwesomeIcon
          icon={faPlus}
          size={size}
          className="gg-text-zinc-400 hover:gg-text-zinc-900"
        />
      </motion.div>
    </div>
  );
};
